import {HistoryUtils} from "./HistoryUtils";

export class DocumentUtils {
    static SetTitle(newValue) {
        document.title = newValue;
    }

    static GetTitle() {
        return document.title;
    }

    static GetQueryStringParameter(key, url = null) {
        if (!url) {
            url = window.location.href;
        }

        let name = key.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
        let results = regex.exec(url);

        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }

        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    static changePage(url) {
        if(url && (url.toLowerCase().startsWith("https://") || url.toLowerCase().startsWith("http://"))) {
            document.location.href = url;
        } else {
            HistoryUtils.Push(url);
        }
    }
}
